import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    return <div className={`${classes.Container} ${props.className}`}>
        <div className={classes.Image}>
            <img src="https://image.geeko.ltd/upgrade/20210225/sp.png"/>
        </div>
    </div>
}